module.exports = __webpack_public_path__ + "static/media/krinqlLogo.854c9516.webp";